import React, {useEffect, useCallback, useContext, memo, useMemo} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import Select from 'react-select';
import styles from './CustomSelect.module.css'
import { setSymbolList } from '../pages/slices/simulationEntriesSlicer';
import { isTokenExpired, handleLogin } from '../pages/utils/AuthenticationHelper';
import axios from 'axios';
import { CsrfTokenContext } from '../CsrfTokenContext';




const CustomSelect = ({ handleChange, selectedOption }) => { 

  const { symbolList } = useSelector(state => state.simulationEntries);  
  const { symbolLimit } = useSelector(state => state.globalData);

  const refreshTokenIfNeeded = useCallback(async () => {
    if (isTokenExpired()) {        
      await handleLogin();
    }    
  },[]);    

  const csrfToken = useContext(CsrfTokenContext); 
  const dispatch = useDispatch();

  useEffect(() => {        
        
    const fetchIcons = async () => {

        try {  
            await refreshTokenIfNeeded();
                    
            const response = await axios.get(`/api/symbols?limit=${symbolLimit}`, {
                method: 'GET',                    
                headers: {                        
                    'Content-Type': 'application/json',
                    'X-CSRFToken': csrfToken
                }
            });
            const serializedData = response.data.map((option) => ({
                "value": option.symbol_name,
                "label": {
                    "symbol_icon": option.symbol_icon,
                    "symbol_name": option.symbol_name,
                    "ranking": option.ranking
                },
                'symbol_icon': option.symbol_icon,
                'ranking': option.ranking
            }));               
        
            dispatch(setSymbolList(serializedData));            
        } catch (error) {
            console.error('Error fetching crypto icons:', error);
        }
    };
    
    
    fetchIcons();    
    
    
}, [dispatch, symbolList.length, csrfToken, symbolLimit, refreshTokenIfNeeded]);

  const mountSelectedSymbol = () => {
    const selectedSbl = selectedOption;

    if (Object.keys(selectedSbl).length === 0) return '';        
    return {
      value: selectedSbl.value,
      label: (
        <div style={{ display: 'flex', backgroundColor:'#ffffff00', color:'#c8c4c4', alignItems: 'center' }}>
          <img
            src={selectedSbl.symbol_icon}
            alt={selectedSbl.value}
            style={{ width: '30px', marginRight: '10px', borderRadius: '50%', }}
          />
          {selectedSbl.value}
          <div style={{ fontSize: '8pt', color:'#c8c4c4' }}>
            &nbsp;({selectedSbl.ranking})
          </div>
        </div>
      ),
      symbol_icon: selectedSbl.symbol_icon,
      ranking: selectedSbl.ranking
    };
  };
 
  const customStyles = useMemo(() => ({
    container: (provided) => ({
      ...provided,
      width: '220px',
      backgroundColor: '#131722',
    }),
    control: (provided) => ({
      ...provided,
      width: '220px',
      backgroundColor: '#131722',
    }),
    menu: (provided) => ({
      ...provided,
      backgroundColor: '#131722',
    }),
    menuList: (provided) => ({
      ...provided,
      backgroundColor: '#131722',
    }),
    option: (provided, state) => ({
      ...provided,
      backgroundColor: state.isSelected
        ? '#465b94'
        : '#131722',
        // : state.isFocused ? '#2f374e' : '#131722',
      padding: 10,
    }),
  }), []);
  
  const formattedOptions = symbolList.map((option) => ({
    value: option.value,
    label: (
        <div style={{ display: 'flex', backgroundColor:'#ffffff00', alignItems: 'center' }}>
            <img
                src={`${option.label.symbol_icon}`}
                alt={option.label.symbol_name}
                style={{ width: '30px', marginRight: '10px', borderRadius: '50%', }}
            />
            {option.label.symbol_name}
            <div style={{ fontSize: '8pt', color: '#c8c4c4' }}>
                &nbsp;({option.label.ranking})
            </div>
        </div>
    ),
    symbol_icon: option.symbol_icon,
    ranking: option.ranking
  }));

  return (
    <div className={styles.select_container}>
        <Select
            id="dropdown"
            // menuPortalTarget={document.body}
            value={mountSelectedSymbol()}
            onChange={handleChange}
            options={formattedOptions}
            styles={customStyles}
            // styles={{customStyles, menuPortal: (base) => ({ ...base, zIndex: 9999})}}
            formatOptionLabel={({ value, label }) => (
                <div style={{ display: 'flex', alignItems: 'center' }}>
                    {label}
                </div>
            )} />
    </div>
   
  );
}

export default memo(CustomSelect);